module.exports = __webpack_public_path__ + "img/mckinley.c171aec9.jpg";